// extracted by mini-css-extract-plugin
export default {"logicQualitySingleCheckWrapper":"LogicQualitySingleCheck_logicQualitySingleCheckWrapper__tE3-L","bottomSection":"LogicQualitySingleCheck_bottomSection__Tktum"};